import { DayCard, ScheduleList } from "./styles";

const formatDayDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric"
  });
};

const formatTimeRange = (startTime, endTime) => {
  if (startTime && endTime) {
    return `${startTime.slice(0, 5)}–${endTime.slice(0, 5)}`;
  }
  if (startTime) {
    return startTime.slice(0, 5);
  }
  if (endTime) {
    return endTime.slice(0, 5);
  }
  return "";
};

const Schedule = ({ days = [], error }) => {
  const hasDays = !error && days.length > 0;

  if (error) {
    return (
      <p className="muted">
        We were unable to load your programme at this time.
      </p>
    );
  }

  if (!hasDays) {
    return (
      <p className="muted">
        Your detailed programme will appear here once it has been assigned to
        your device.
      </p>
    );
  }

  return (
    <ScheduleList>
      {days.map((day) => (
        <DayCard key={day.id}>
          <p className="day-date">{formatDayDate(day.date)}</p>
          {day.title && <h3>{day.title}</h3>}
          {day.subtitle && <p className="muted">{day.subtitle}</p>}
          {day.agendaItems?.map((item) => {
            const time = formatTimeRange(item.startTime, item.endTime);
            const startTimePrefix = item.startTimePrefix || "";
            return (
              <div className="agenda-item" key={item.id}>
                <p className="time">
                  {startTimePrefix} {time}
                </p>
                <div>
                  <p className="bold">{item.title}</p>
                  {item.description && <p className="muted">{item.description}</p>}
                </div>
              </div>
            );
          })}
        </DayCard>
      ))}
    </ScheduleList>
  );
};

export default Schedule;
